/* countdown-amatora.js · actualiza cada segundo los [data-countdown-am] de snippets/countdown-amatora.liquid.
   Busca los contadores en cada vuelta, así también funciona después de que el carrito se vuelve a pintar. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const put = (el, k, v) => {
    const n = el.querySelector('[data-cd-' + k + ']');
    if (n && n.textContent !== String(v)) n.textContent = v;
  };
  const tick = () => {
    const now = Date.now();
    document.querySelectorAll('[data-countdown-am]').forEach((el) => {
      let s = Math.floor((Number(el.dataset.end) - now) / 1000);
      if (!(s > 0)) {
        (el.closest('[data-countdown-wrap]') || el).style.display = 'none';
        return;
      }
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      put(el, 'd', d); put(el, 'h', pad(h)); put(el, 'm', pad(m)); put(el, 's', pad(s));
    });
  };
  tick();
  setInterval(tick, 1000);
})();
